// IMPORTANT: I ​​created this component temporarily because the ones currently in @utriper/core-ui are a disaster...

import React from 'react';
import { DatePicker as MUIDatePicker } from '@mui/x-date-pickers/DatePicker';

const DatePicker = ({ input, meta, label, placeholder, disabled, required, ...props }) => {
    return (
        <MUIDatePicker
            {...props}
            label={label}
            value={input?.value ?? null}
            onChange={input?.onChange}
            disabled={disabled}
            views={['year', 'month', 'day']}
            openTo={"day"}
            slotProps={{
                textField: {
                    required,
                    placeholder,
                    error: meta?.touched && Boolean(meta?.error),
                    helperText: meta?.touched ? meta?.error : undefined,
                    sx: { width: '100%' },
                },
            }}
        />
    );
};

export default DatePicker;
